import * as React from 'react';
import { useState, useEffect } from 'react'
import { Box, IconButton, Typography, Button, Checkbox } from '@mui/material'
import IconoChecklist from '../../assets/IconoChecklist.svg';
import IconoTimer from '../../assets/IconoTimer.svg';
import { addDoc, collection, doc, getDocs, getFirestore, setDoc } from 'firebase/firestore';
import EmailIcon from '@mui/icons-material/Email';
import { useStateValue } from '../../StateProvider';
import NavRepartidor from './NavRepartidor';

const Repartidor = () => {
  const [showMenu, setShowMenu] = useState(true)
  const [toBeDelivered, settoBeDelivered] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [showDelivered, setShowDelivered] = useState(false)
  const db = getFirestore()
  const [packagedOrders, setPackagedOrders] = useState([])
  const [delivered, setDelivered] = useState([])
  const [orderDetails, setOrderDetails] = useState([])
  const [updateOrderList, setUpdateOrderList] = useState(false)
  const [{ user }] = useStateValue();

  async function getOrders() {
    const query = await getDocs(collection(db, 'orders'))
    let dataOrders = []
    let dataDelivered = []
    query.forEach((doc) => {
      Object.keys(doc.data().orders).forEach(async (key) => {
        let item = doc.data().orders[key]
        item.id = key
        item.idUser = doc.id
        if (item.statusOrder === "empacado") {
          dataOrders = [...dataOrders, item]
        } else if (item.statusOrder === "entregado") {
          dataDelivered = [...dataDelivered, item]
        }
      })
    })
    dataOrders.sort((a, b) => b.date.seconds - a.date.seconds)
    setPackagedOrders([...dataOrders])
    setDelivered([...dataDelivered])
  }
  useEffect(() => {
    getOrders()
  }, [updateOrderList])

  const handleDelivered = async () => {
    try {
      let orders = {}
      orders[orderDetails.id] = {
        statusOrder: "entregado",
        deliberyDetails: {
          user: user.displayName,
          date: new Date()
        }
      }
      await setDoc(doc(db, 'orders', orderDetails.idUser), {
        orders
      }, { merge: true })
      setShowDetails(false)
      settoBeDelivered(true)
      setUpdateOrderList(!updateOrderList)

      addDoc(collection(db, 'mail'), emailContent)
    } catch (error) {
      console.log()
    }
  }
  const emailContent = {
    to: orderDetails.email,
    message: {
      subject: "Tu pedido ha sido entregado",
      text: "¡Hola! , aqui esta tu pedido",
      html: `
          <body>
            <table style="width: 600px;height: 368px;font-family: 'Quicksand';background-image: url(https://firebasestorage.googleapis.com/v0/b/allfresco-52e3c.appspot.com/o/categories%2Fbg-mail.webp?alt=media&token=700902bf-b48a-4357-b067-a0dfb30c3a3e);background-position: center;background-size: cover;" >
            <tbody>
              <tr>
                <th>
                  <img src="https://develop.allfresco.mx/static/media/cereza.136f873677aece390bd6.png" alt="allfresco logo" width="35px" height="35px"  />
                  <h1 style="color: #43ABAE;margin: 0px;" >allfresco</h1>
                </th>
              </tr>
              <tr>
                <th>
                  <h2 style="font-size:16px;color: #B6D33C; margin: 0px;" >¡Hola!</h2>
                </th>
              </tr>
              <tr>
                <th>
                  <p style="color: #707070;font-family: 'Open sans';margin-bottom: 0px;font-weight: 400;" >Tu pedido ha sido entregado!</p>
            <p style="color: #707070;font-family: 'Open sans'; margin: 0px;font-weight: 400;" >Gracias por comprar con nosotros</p>
                </th>
              </tr>
              <tr>
                <th>
                  <button style="background-color: #B6D33C;border: none; border-radius: 5px;padding: 5px;margin-top: 15px;margin-bottom: 15px;" > <a style="text-decoration: none; color: white;" href="https://www.allfresco.mx" target="_blank">Comenzar con tu compra</a> </button>
                </th>
              </tr>
              <tr>
                <th>
                  <div >
                    <span style="text-align: center;font-size: 12px;color: #43ABAE;" >Siguenos</span>
                    <div  >
                      <svg id="Grupo_1805" data-name="Grupo 1805" xmlns="http://www.w3.org/2000/svg" width="13.246" height="13.246" viewBox="0 0 13.246 13.246">
                        <path id="Trazado_1970" data-name="Trazado 1970" d="M6.623,0a6.623,6.623,0,1,0,6.623,6.623A6.623,6.623,0,0,0,6.623,0M9.23,3.344H8.454a.889.889,0,0,0-1,.961V5.459H9.158L8.885,7.237H7.452v4.3H5.529v-4.3H3.967V5.459H5.529V4.1A2.171,2.171,0,0,1,7.853,1.71a9.456,9.456,0,0,1,1.377.12Z" fill="#3eb1b4"/>
                      </svg>
                      <svg id="Grupo_1804" data-name="Grupo 1804" xmlns="http://www.w3.org/2000/svg" width="13.246" height="13.246" viewBox="0 0 13.246 13.246">
                        <path id="Trazado_1967" data-name="Trazado 1967" d="M74.787,13.415a1.266,1.266,0,1,0,1.266,1.266,1.268,1.268,0,0,0-1.266-1.266" transform="translate(-68.132 -8.059)" fill="#3eb1b4"/>
                        <path id="Trazado_1968" data-name="Trazado 1968" d="M73.309,8.425H70.1a1.658,1.658,0,0,0-1.656,1.656v3.206A1.658,1.658,0,0,0,70.1,14.943h3.205a1.658,1.658,0,0,0,1.657-1.656V10.081a1.658,1.658,0,0,0-1.657-1.656m-1.57,5.236a1.977,1.977,0,1,1,1.977-1.977,1.979,1.979,0,0,1-1.977,1.977m2.093-3.617a.471.471,0,1,1,.471-.471.471.471,0,0,1-.471.471" transform="translate(-65.084 -5.061)" fill="#43abae"/>
                        <path id="Trazado_1969" data-name="Trazado 1969" d="M66.646,0a6.623,6.623,0,1,0,6.623,6.623A6.623,6.623,0,0,0,66.646,0M70.66,8.226a2.414,2.414,0,0,1-2.412,2.412H65.043a2.414,2.414,0,0,1-2.412-2.412V5.02a2.415,2.415,0,0,1,2.412-2.412h3.205A2.415,2.415,0,0,1,70.66,5.02Z" transform="translate(-60.023)" fill="#3eb1b4"/>
                      </svg> 
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th>
                  <ul style="list-style-type: none; display: flex; color: #43ABAE;font-weight: 500;font-size: 16px;" >
                    <li >Acerca de allfresco</li>
                    <li style="margin-left: 10px;">Ayuda</li>
                    <li style="margin-left: 10px;margin-right: 10px;" >Privacidad</li>
                    <li>Terminos y condiciones</li>
                  </ul>
                </th>
              </tr>
            </tbody>
          </table>
          </body>
          `
    }
  }

  const sendEmail = async (userEmail) => {
    try {
      await addDoc(collection(db, 'mail'), {
        to: userEmail,
        message: {
          subject: "Ya casi llega!",
          text: "¡Hola! , tu pedido va en camino",
          html: `
              <body>
                <table style="width: 600px;height: 368px;font-family: 'Quicksand';background-image: url(https://firebasestorage.googleapis.com/v0/b/allfresco-52e3c.appspot.com/o/categories%2Fbg-mail.webp?alt=media&token=700902bf-b48a-4357-b067-a0dfb30c3a3e);background-position: center;background-size: cover;" >
                <tbody>
                  <tr>
                    <th>
                      <img src="https://develop.allfresco.mx/static/media/cereza.136f873677aece390bd6.png" alt="allfresco logo" width="35px" height="35px"  />
                      <h1 style="color: #43ABAE;margin: 0px;" >allfresco</h1>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <h2 style="font-size:16px;color: #B6D33C; margin: 0px;" >¡Hola!</h2>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <p style="color: #707070;font-family: 'Open sans';margin-bottom: 0px;font-weight: 400;" >Te informamos que tu pedido va en camino a tu domicilio.!</p>
                <p style="color: #707070;font-family: 'Open sans'; margin: 0px;font-weight: 400;" >Gracias por comprar con nosotros</p>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <button style="background-color: #B6D33C;border: none; border-radius: 5px;padding: 5px;margin-top: 15px;margin-bottom: 15px;" > <a style="text-decoration: none; color: white;" href="https://www.allfresco.mx/profile" target="_blank">Haz el seguimiento aqui</a> </button>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <div >
                        <span style="text-align: center;font-size: 12px;color: #43ABAE;" >Siguenos</span>
                        <div  >
                          <svg id="Grupo_1805" data-name="Grupo 1805" xmlns="http://www.w3.org/2000/svg" width="13.246" height="13.246" viewBox="0 0 13.246 13.246">
                            <path id="Trazado_1970" data-name="Trazado 1970" d="M6.623,0a6.623,6.623,0,1,0,6.623,6.623A6.623,6.623,0,0,0,6.623,0M9.23,3.344H8.454a.889.889,0,0,0-1,.961V5.459H9.158L8.885,7.237H7.452v4.3H5.529v-4.3H3.967V5.459H5.529V4.1A2.171,2.171,0,0,1,7.853,1.71a9.456,9.456,0,0,1,1.377.12Z" fill="#3eb1b4"/>
                          </svg>
                          <svg id="Grupo_1804" data-name="Grupo 1804" xmlns="http://www.w3.org/2000/svg" width="13.246" height="13.246" viewBox="0 0 13.246 13.246">
                            <path id="Trazado_1967" data-name="Trazado 1967" d="M74.787,13.415a1.266,1.266,0,1,0,1.266,1.266,1.268,1.268,0,0,0-1.266-1.266" transform="translate(-68.132 -8.059)" fill="#3eb1b4"/>
                            <path id="Trazado_1968" data-name="Trazado 1968" d="M73.309,8.425H70.1a1.658,1.658,0,0,0-1.656,1.656v3.206A1.658,1.658,0,0,0,70.1,14.943h3.205a1.658,1.658,0,0,0,1.657-1.656V10.081a1.658,1.658,0,0,0-1.657-1.656m-1.57,5.236a1.977,1.977,0,1,1,1.977-1.977,1.979,1.979,0,0,1-1.977,1.977m2.093-3.617a.471.471,0,1,1,.471-.471.471.471,0,0,1-.471.471" transform="translate(-65.084 -5.061)" fill="#43abae"/>
                            <path id="Trazado_1969" data-name="Trazado 1969" d="M66.646,0a6.623,6.623,0,1,0,6.623,6.623A6.623,6.623,0,0,0,66.646,0M70.66,8.226a2.414,2.414,0,0,1-2.412,2.412H65.043a2.414,2.414,0,0,1-2.412-2.412V5.02a2.415,2.415,0,0,1,2.412-2.412h3.205A2.415,2.415,0,0,1,70.66,5.02Z" transform="translate(-60.023)" fill="#3eb1b4"/>
                          </svg> 
                        </div>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <ul style="list-style-type: none; display: flex; color: #43ABAE;font-weight: 500;font-size: 16px;" >
                        <li >Acerca de allfresco</li>
                        <li style="margin-left: 10px;">Ayuda</li>
                        <li style="margin-left: 10px;margin-right: 10px;" >Privacidad</li>
                        <li>Terminos y condiciones</li>
                      </ul>
                    </th>
                  </tr>
                </tbody>
              </table>
              </body>
              `
        }
      })
      alert("Email enviado a:" + userEmail)
    } catch (error) {
      console.log(error)
    }
  }

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  return (
    <div>


      {/* ********** MENU *************** */}
      <Box height="8px" ></Box>
      <Box display={showMenu ? "flex" : "none"} justifyContent="space-around" flexDirection="column" alignItems="center" marginBottom="3rem">
        <IconButton sx={{ backgroundColor: "#43ABAE", borderRadius: "10px", width: "200px", marginTop: "2rem", height: "200px", display: 'flex', flexDirection: 'column' }} onClick={() => { setShowMenu(false); settoBeDelivered(true) }} >
          <svg width="114.146" height="68.513" viewBox="0 0 114.146 68.513">
            <defs>
              <clipPath id="clip-path">
                <rect id="Rectángulo_1279" data-name="Rectángulo 1279" width="114.146" height="68.513" fill="none" />
              </clipPath>
            </defs>
            <g id="Grupo_1732" data-name="Grupo 1732" clip-path="url(#clip-path)">
              <path id="Trazado_1990" data-name="Trazado 1990" d="M0,54.334c.534-.738,1.115-1.447,1.58-2.226a2.708,2.708,0,0,0,.316-1.33q.024-20.28,0-40.56A9.773,9.773,0,0,1,5.612,2.026,10.135,10.135,0,0,1,12.181.011Q37.475.03,62.769.018c4.011,0,8.023-.047,12.034.011,6.683.1,11.544,3.139,14.423,9.2q5.345,11.256,10.6,22.553a2.669,2.669,0,0,0,1.517,1.474c2.914,1.2,5.788,2.495,8.7,3.7a6.079,6.079,0,0,1,4.1,6.222c-.052,4.494-.008,8.988-.015,13.483-.006,3.754-2.375,6.2-6.109,6.11a3.372,3.372,0,0,0-3.348,1.721,9.374,9.374,0,0,1-15.9-.816,1.507,1.507,0,0,0-1.555-.883q-25.405.026-50.811,0a1.516,1.516,0,0,0-1.547.881,9.035,9.035,0,0,1-8.233,4.817A9.041,9.041,0,0,1,18.4,63.673a1.512,1.512,0,0,0-1.549-.882c-4.011.031-8.025-.065-12.033.045C2.485,62.9.884,62.07,0,59.907V54.334M87.852,15.269c-.728-1.56-1.379-2.959-2.035-4.357A11.436,11.436,0,0,0,74.686,3.833q-31.317-.009-62.634,0c-4.072,0-6.327,2.277-6.328,6.366q-.007,19.949,0,39.9v1.311c1.243,0,2.348-.007,3.453,0a3.831,3.831,0,0,1,4.158,4.166c.012,1.1,0,2.21,0,3.362H17.05c.527-6.647,5.466-9.37,9.345-9.447a9.267,9.267,0,0,1,6.018,1.971,9.69,9.69,0,0,1,3.767,7.495H87.429c.047-.252.1-.463.125-.678a9.445,9.445,0,0,1,14.556-7.271,1.806,1.806,0,0,0,.783.374c2.441.029,4.882.017,7.442.017,0-2.849-.035-5.588.015-8.325a2.431,2.431,0,0,0-1.675-2.569c-3.083-1.278-6.131-2.64-9.213-3.92A5.257,5.257,0,0,0,97.53,36.2c-4.495-.033-8.99.015-13.485-.027-4.779-.045-7.936-3.244-7.973-8.011-.017-2.229-.012-4.458,0-6.687.018-3.854,2.333-6.183,6.164-6.2,1.808-.01,3.617,0,5.617,0m8.062,17.094c-2.082-4.419-4.039-8.606-6.052-12.766a1.383,1.383,0,0,0-1.056-.5c-2.223-.045-4.448-.034-6.672-.018-1.561.011-2.232.666-2.249,2.243-.026,2.335-.036,4.671,0,7.006a3.779,3.779,0,0,0,4.055,4.029c1.631.03,3.262.007,4.893.007h7.079M32.325,58.988A5.69,5.69,0,1,0,26.7,64.7a5.726,5.726,0,0,0,5.622-5.709m64.586,5.7a5.7,5.7,0,1,0-5.571-5.968,5.664,5.664,0,0,0,5.571,5.968M9.433,55.3H3.865V58.96H9.433Zm100.8-.023h-4.344l.763,3.631c3.115.427,4-.451,3.58-3.631" transform="translate(0 0)" fill="#fff" />
              <path id="Trazado_1991" data-name="Trazado 1991" d="M387.161,470.225c6.5,0,12.992-.007,19.488.013a2.452,2.452,0,0,1,1.567.339,2.592,2.592,0,0,1,.776,1.784,2.552,2.552,0,0,1-1.124,1.463,2.591,2.591,0,0,1-1.4.194q-19.209.013-38.418.007c-.223,0-.446.009-.668,0a1.967,1.967,0,0,1-2.017-1.943,1.908,1.908,0,0,1,2.086-1.844c5.085-.015,10.171-.007,15.256-.008h4.454" transform="translate(-325.42 -418.816)" fill="#fff" />
              <path id="Trazado_1992" data-name="Trazado 1992" d="M382.741,109.051c-.162-.743-.056-.177-.19-.9q-.05-.27-.092-.542-.022-.141-.042-.281l-.009-.064c0-.012,0-.024-.005-.036,0,.005.01.071,0,.021l-.019-.146q-.07-.554-.114-1.111c-.057-.727-.083-1.456-.084-2.186q0-1.03.061-2.06.053-.908.15-1.813.042-.393.092-.785l.024-.184c.006-.047-.011.082,0,.026l.005-.04.012-.091q.023-.167.047-.335.075-.512.165-1.022c.028-.158.06-.315.09-.473,0-.007,0-.014,0-.02.152-.526-.379-.714-.545-.283l-.087.455q-.084.454-.153.91-.111.724-.2,1.452-.1.876-.165,1.756-.072,1.009-.087,2.022c-.01.728,0,1.456.047,2.182.046.768.126,1.534.245,2.294.116.738.13.634.269,1.364Z" transform="translate(-339.881 -85.936)" fill="#fff" />
              <path id="Trazado_1993" data-name="Trazado 1993" d="M388.847,96.751c.169.282.355.554.544.823a12.464,12.464,0,0,0,1.333,1.621,5.155,5.155,0,0,0,.911.744.3.3,0,0,0,.4-.121.3.3,0,0,0-.121-.4l-.091-.059-.049-.033-.018-.013c-.047-.033.059.043.013.009-.064-.047-.127-.1-.188-.146-.131-.107-.257-.221-.378-.339s-.243-.246-.359-.374q-.09-.1-.178-.2l-.081-.1c-.045-.054.032.039,0,0l-.048-.058a15.544,15.544,0,0,1-1.009-1.387c-.062-.1-.123-.191-.182-.288a.3.3,0,0,0-.407-.091.3.3,0,0,0-.091.407" transform="translate(-346.297 -85.77)" fill="#fff" />
              <path id="Trazado_1994" data-name="Trazado 1994" d="M406.2,123.266s-1.49,2.783-.393,5.043c1.3,2.669,3.763,3.585,4.565,4.552,0,0,2.379-8.458-4.172-9.595" transform="translate(-361.081 -109.79)" fill="#fff" />
              <path id="Trazado_1995" data-name="Trazado 1995" d="M387.648,211.367q-.243.039-.481.089Z" transform="translate(-344.84 -188.259)" fill="#fff" />
              <path id="Trazado_1996" data-name="Trazado 1996" d="M325.939,210.235a9.883,9.883,0,0,0-1.5.115c.215.71.12.544.353,1.246q.085.258.181.512.047.124.1.247l.027.068,0,.01.052.121a10.482,10.482,0,0,0,.469.953,9.033,9.033,0,0,0,.565.89l.081.11.006.008.031.041q.081.1.165.206a4.578,4.578,0,0,0,.333.325,3.973,3.973,0,0,1,5.143,2.213c2.135,4.26-1.959,9.02-6.986,8.267-6.051-.907-6.66-6.61-4.343-9.6,1.856-2.4,4.119-1.395,5.261-.957a9.925,9.925,0,0,1-1-1.645,24.348,24.348,0,0,1-1.017-2.9,9.8,9.8,0,1,0,2.081-.224" transform="translate(-281.577 -187.251)" fill="#fff" />
            </g>
          </svg>
          <Typography color="white" >Por entregar</Typography>
        </IconButton>
        <IconButton sx={{ backgroundColor: "#43ABAE", borderRadius: "10px", width: "200px", marginTop: "20px", height: "200px", display: 'flex', flexDirection: 'column' }} onClick={() => { setShowDelivered(true); setShowMenu(false) }}  >
          <svg id="Grupo_1627" data-name="Grupo 1627" xmlns="http://www.w3.org/2000/svg"  width="75.231" height="102.942" viewBox="0 0 75.231 102.942">
            <defs>
              <clipPath id="clip-path">
                <rect id="Rectángulo_1240" data-name="Rectángulo 1240" width="75.231" height="102.942" fill="#fff" />
              </clipPath>
            </defs>
            <g id="Grupo_1626" data-name="Grupo 1626" clip-path="url(#clip-path)">
              <path id="Trazado_42" data-name="Trazado 42" d="M285.169,319.81V319.8a.079.079,0,0,1,0,.009" transform="translate(-248.656 -278.854)" fill="#fff" />
              <path id="Trazado_43" data-name="Trazado 43" d="M299.484,481.709a1.74,1.74,0,0,0-1.779,1.21h3.448a1.567,1.567,0,0,0-1.67-1.21" transform="translate(-259.587 -420.032)" fill="#fff" />
              <path id="Trazado_44" data-name="Trazado 44" d="M285.18,319.873c0,.016,0,.012,0,0v0" transform="translate(-248.665 -278.914)" fill="#fff" />
              <path id="Trazado_45" data-name="Trazado 45" d="M73.69,0H72.548c-2.146,1.854-4.3,3.691-6.431,5.574-.458.405-.777.473-1.27.047C63.319,4.3,61.753,3.04,60.19,1.779,59.425,1.161,58.635.591,57.857,0H56.551q-2.784,2.58-5.566,5.16c-.258.239-.508.492-.834.81-1.28-1.261-2.516-2.551-3.816-3.734-.9-.821-1.892-1.5-2.843-2.236h-.653c-1.03.834-2.093,1.615-3.083,2.515-1.2,1.089-2.334,2.279-3.529,3.457-1.449-1.425-2.845-2.855-4.294-4.2A28.517,28.517,0,0,0,29.617,0h-.653A24.709,24.709,0,0,0,26.7,1.667c-1.282,1.171-2.535,2.4-3.737,3.688-.538.578-.866.474-1.358-.037C20.362,4.029,19.1,2.763,17.8,1.576A20.973,20.973,0,0,0,15.579,0h-.49a20.3,20.3,0,0,0-2.276,1.641c-1.482,1.39-2.9,2.884-4.34,4.333L2.683,0H1.541C.4.656,0,1.745,0,3.3Q.037,49.382.02,95.463c0,4.7,2.276,7.478,6.1,7.478q31.578,0,63.156,0c2.953,0,5.139-1.985,5.777-5.285a11.165,11.165,0,0,0,.155-2.091q.011-46.182.023-92.364A3.312,3.312,0,0,0,73.69,0M15.845,60.431a2.414,2.414,0,0,1,2.081,1.053v-.4a.468.468,0,0,1,.508-.52h.532a.477.477,0,0,1,.52.52V66.2a.468.468,0,0,1-.52.508h-.532a.459.459,0,0,1-.508-.508v-.411a2.414,2.414,0,0,1-2.081,1.053,3.213,3.213,0,0,1,0-6.413M22.729,66.2a.459.459,0,0,1-.508.508h-.544a.459.459,0,0,1-.508-.508V58.471a.459.459,0,0,1,.508-.508h.544a.459.459,0,0,1,.508.508Zm3.279,0a.459.459,0,0,1-.508.508h-.544a.459.459,0,0,1-.508-.508V58.471a.459.459,0,0,1,.508-.508H25.5a.459.459,0,0,1,.508.508Zm6.195-6.57a.231.231,0,0,1-.254.182h-.726a.227.227,0,0,1-.254-.218v-.085c0-.266-.266-.448-.605-.448-.472,0-.714.351-.714.9v.653h1.21a.249.249,0,0,1,.278.278v.581a.249.249,0,0,1-.278.278H29.673V66.2a.459.459,0,0,1-.508.508H28.62a.468.468,0,0,1-.52-.508V61.75h-.617a.249.249,0,0,1-.278-.278v-.581a.249.249,0,0,1,.278-.278H28.1v-.423c0-1.924,1.174-2.347,2.166-2.347,1.137,0,1.96.569,1.96,1.6a1.074,1.074,0,0,1-.024.194m3.883,1.912c0,.315-.145.448-.375.411a1.478,1.478,0,0,0-.315-.036c-.581,0-1.452.351-1.452,2.359V66.2a.468.468,0,0,1-.52.508h-.533a.459.459,0,0,1-.508-.508V61.084a.468.468,0,0,1,.508-.52H33.4a.468.468,0,0,1,.508.52v.847a1.711,1.711,0,0,1,1.621-1.5,1.829,1.829,0,0,1,.242.024c.266.024.315.242.315.484Zm6.473,2.323H38.045c-.024.932.8,1.694,2.069,1.694a2.771,2.771,0,0,0,1.512-.448.515.515,0,0,1,.714.1l.109.133a.489.489,0,0,1-.1.774,3.712,3.712,0,0,1-2.311.726,3.214,3.214,0,1,1-.169-6.413,3.01,3.01,0,0,1,3.194,2.952c.024.315-.181.484-.508.484M37.615,53.719A5.877,5.877,0,0,1,36.367,42.1c-.082-.428-.091-.37-.16-.809-.071-.456-.119-.915-.147-1.376-.026-.436-.034-.872-.028-1.309q.008-.607.052-1.213.037-.528.1-1.053.051-.437.117-.871.042-.273.092-.546l.052-.273a.2.2,0,0,1,.166-.143.181.181,0,0,1,.217.069c.035.058.072.116.109.173a9.3,9.3,0,0,0,.605.832l.027.033v0l.049.057.107.121c.07.077.141.152.215.224s.148.139.227.2c.035.029.071.056.107.083,3.671.822,2.3,5.713,2.3,5.713-.481-.58-1.961-1.129-2.738-2.73a3.549,3.549,0,0,1,.124-2.784,3.6,3.6,0,0,1-.3-.271,7.481,7.481,0,0,1-.8-.972c-.044-.063-.088-.127-.131-.191l-.009.046q-.054.305-.1.613-.015.1-.028.2l-.007.054,0,.013-.014.106q-.03.235-.055.471-.058.543-.09,1.087-.036.617-.036,1.235c0,.437.016.875.051,1.311q.026.334.068.666l.01.08,0,.012v0l.005.038q.012.085.025.169.025.163.055.325c.08.436.017.1.114.543l-.345.064a14.535,14.535,0,0,0,.608,1.734,5.947,5.947,0,0,0,.6.987,2.4,2.4,0,0,0-3.155.574,3.556,3.556,0,0,0,2.6,5.758c3.015.452,5.471-2.4,4.19-4.958a2.383,2.383,0,0,0-3.084-1.327,2.738,2.738,0,0,1-.2-.195q-.05-.061-.1-.123l-.019-.024,0,0-.048-.066a5.4,5.4,0,0,1-.339-.533,6.32,6.32,0,0,1-.281-.572l-.031-.073,0-.006-.017-.04c-.02-.049-.039-.1-.058-.148q-.058-.152-.109-.307c-.14-.421-.082-.322-.211-.747a5.878,5.878,0,1,1,.9,11.685m8.608,13.124a2.464,2.464,0,0,1-2.311-1.21c-.157-.327.012-.557.339-.641l.315-.073c.29-.073.436.06.641.29a1.308,1.308,0,0,0,1.016.436c.533,0,.907-.29.907-.678,0-.327-.254-.5-.653-.641l-.787-.278c-.786-.242-1.633-.726-1.633-1.73a1.968,1.968,0,0,1,2.166-1.888,2.06,2.06,0,0,1,1.912.98c.206.315.036.569-.3.653l-.278.073a.587.587,0,0,1-.641-.242.815.815,0,0,0-.666-.278.67.67,0,0,0-.75.641c0,.327.29.5.629.6l.823.29c1.222.387,1.609,1.1,1.621,1.8,0,1.234-1.089,1.888-2.347,1.888m6.763-1.295a2.65,2.65,0,0,0,1.065-.242c.3-.145.532-.133.714.121l.145.194c.194.266.133.581-.266.786a3.623,3.623,0,0,1-1.742.436,3.219,3.219,0,1,1,0-6.413,3.723,3.723,0,0,1,1.887.52.441.441,0,0,1,.121.714l-.145.181c-.193.266-.411.278-.714.133a2.449,2.449,0,0,0-1.065-.242,1.91,1.91,0,1,0,0,3.811m6.086,1.295A3.209,3.209,0,1,1,62.4,63.637a3.229,3.229,0,0,1-3.327,3.206" transform="translate(0)" fill="#fff" />
              <path id="Trazado_46" data-name="Trazado 46" d="M114.249,485.91a1.915,1.915,0,0,0,0-3.823,1.92,1.92,0,0,0,0,3.823" transform="translate(-98.102 -420.362)" fill="#fff" />
              <path id="Trazado_47" data-name="Trazado 47" d="M449,482.182a1.9,1.9,0,1,0,1.815,1.912A1.851,1.851,0,0,0,449,482.182" transform="translate(-389.932 -420.444)" fill="#fff" />
            </g>
          </svg>

          <Typography color="white" >Pedidos entregados</Typography>
        </IconButton>
      </Box>

      {/* ************ POR ENTREGAR ****************** */}
      <Box display={toBeDelivered ? "block" : "none"}  >
        <Box sx={{ background: "#B6D33C" }} >
          <Button onClick={() => { settoBeDelivered(false); setShowMenu(true) }} ><span className="icon-Atras-mvil-allfresco" style={{ color: "white" }} ></span></Button>
          <Typography sx={{ display: "inline-block" }} >Por entregar</Typography>
        </Box>

        <Typography marginLeft={2} variant='caption' >Se muestran {packagedOrders.length} resultados</Typography>
        {
          packagedOrders.length > 0 ? packagedOrders.map(order => <Box boxShadow="rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px" margin={2} padding={1} key={order.id} >
            <Typography variant='subtitle1' color="primary" >#{order.id}</Typography>
            <Typography variant='subtitle2' >{order.username}</Typography>
            <Button color='secondary' variant='outlined' onClick={() => sendEmail(order.email)} >Enviar email <EmailIcon sx={{ marginLeft: 2 }} /> </Button>
            <Typography variant='caption' display="block" >{(new Date(order.date.seconds * 1000)).toLocaleString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</Typography>
            <Typography gutterBottom variant='caption' display="block" >Entrega {order.time.dateDelivery}, hora: {order.time.time}</Typography>
            <Button sx={{ fontWeight: "bold", textTransform: "none" }} fullWidth variant="contained" onClick={() => { settoBeDelivered(false); setShowDetails(true); setOrderDetails(order) }} >Ver detalles</Button>
          </Box>) : <Typography>Sin resultados</Typography>
        }
      </Box>
      {/* *************** DETALLES DEL PEDIDO ****************** */}
      <Box m={1} p={1} display={showDetails ? "block" : "none"}>
        <Button onClick={() => { settoBeDelivered(true); setShowDetails(false) }} ><span className="icon-Atras-mvil-allfresco"  ></span></Button>
        {
          orderDetails.username ? <>
            <Box display="flex" justifyContent="space-between" >
              <Box>
                <img src={IconoTimer} alt="Icono -relog" width="77px" />
                <Typography>En preparacion</Typography>
              </Box>
              <Box width="90%" marginTop="35px" height="10px" sx={{ background: "#B6D33C" }} ></Box>
              <Box>
                <img src={IconoChecklist} width="77px" alt="Icono-checklist" />
                <Typography>Entregado</Typography>
              </Box>
            </Box>
            <Typography variant='subtitle1' color="primary" >#{orderDetails.id}</Typography>
            <Typography variant='subtitle2' >{orderDetails.username}</Typography>
            {/* <Typography variant='caption' >07 de Junio de 2022</Typography> */}
            <Typography gutterBottom variant='caption' display="block" >Entrega: {orderDetails.time.dateDelivery}, hora: {orderDetails.time.time}</Typography>
            <Button sx={{ fontWeight: "bold", textTransform: "none" }} fullWidth variant="contained"  >Imprimir</Button>
            <hr></hr>

            <Typography marginY={2} > {Object.keys(orderDetails.products).length} productos </Typography>
            {
              Object.entries(orderDetails.products).map(product => <Box marginY={1} boxShadow="rgba(0, 0, 0, 0.04) 0px 3px 5px" display="flex" key={product[1].nombre} >
                <img src={product[1].url} style={{ boxShadow: "rgba(0, 0, 0, 0.04) 0px 3px 5px" }} width="100px" alt="imagen de producto" />
                <Box marginLeft={2}>
                  <Typography variant='h6' > {product[1].nombre} </Typography>
                  <Typography>{product[1].quantity} {product[1].unit}</Typography>
                  <Typography>$subtotal</Typography>
                  {/* <Typography> {product[1].subtotal} </Typography> */}
                </Box>
              </Box>)
            }

            <Box>
              <Typography variant='h5' >Resumen del Pedido</Typography>
              <Typography variant='body1' >El pago del cliente se ha realizado orrectamente</Typography>
              <Box display="flex" justifyContent="space-between">
                <Typography>Metodo de pago:</Typography>
                <Typography>Credito</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography>Subtotal( {Object.keys(orderDetails.products).length} productos ):</Typography>
                <Typography>${orderDetails.basketTotal}.00</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography>Costo de Envio:</Typography>
                <Typography>${orderDetails.shippingPrice}</Typography>
              </Box>
              <Box>
                <Typography>Descuentos:</Typography>
              </Box >
              <Box display="flex" justifyContent="space-between">
                <Typography>Wallet:</Typography>
                <Typography>$0.00</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" >
                <Typography color="#B6D33C" >Total:</Typography>
                <Typography color="#B6D33C" >${orderDetails.basketTotal + orderDetails.shippingPrice}</Typography>
              </Box>
              <Button variant='contained' >Reportar un problema</Button>
            </Box>
            <Button sx={{ fontWeight: "bold", textTransform: "none", marginTop: "20px" }} fullWidth variant="contained" onClick={() => handleDelivered()} >Entregado</Button>
          </> : null
        }

      </Box>

      {/* ********************* PEDIDOS ENTREGADOS ********************* */}
      <Box display={showDelivered ? "block" : "none"} >
        <Box sx={{ background: "#B6D33C" }} >
          <Button onClick={() => { setShowDelivered(false); setShowMenu(true) }} ><span className="icon-Atras-mvil-allfresco" style={{ color: "white" }} ></span></Button>
          <Typography sx={{ display: "inline-block" }} >Pedidos Entregados</Typography>
        </Box>

        <Typography marginLeft={2} variant='caption' >Se muestran {delivered.length} resultados</Typography>

        {
          delivered.length > 0 ? delivered.map(order => <Box boxShadow="rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px" margin={2} padding={1} key={order.id} >
            <Typography variant='subtitle1' color="primary" >#{order.id}</Typography>
            <Typography variant='subtitle2' >{order.username}</Typography>
            <Typography variant='caption' >{order.time.dateDelivery}</Typography>
            <Typography gutterBottom variant='caption' display="block" >{order.time.time}</Typography>
            <Checkbox
              {...label}
              defaultChecked
              sx={{
                color: "#B6D33C",
                '&.Mui-checked': {
                  color: "#B6D33C",
                },
              }}
            /> <Typography variant='h6' display="inline-block" >Entregado</Typography>
          </Box>) : <Typography>No se muestran resultados</Typography>
        }

      </Box>
    </div>
  )
}

export default Repartidor



